import { useEffect } from "react";
import { useLocation } from "@/lib/router-compat";
import { usePageViewTracker } from "@/hooks/useAnalytics";
import { trackEvent } from "@/hooks/useAnalytics";
import { pageview, gtagEvent } from "@/lib/gtag";

/** Drop inside <BrowserRouter> to auto-track page views and click-to-call */
const PageViewTracker = () => {
  usePageViewTracker();
  const { pathname } = useLocation();

  // GA4 page view on route change
  useEffect(() => {
    pageview(pathname);
  }, [pathname]);

  // Global listener: track every tel: link click site-wide
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest?.("a[href^='tel:']") as HTMLAnchorElement | null;
      if (anchor) {
        // Resolve the CTA location: nearest [data-cta] ancestor on or above the anchor
        const ctaEl = anchor.closest("[data-cta]") as HTMLElement | null;
        const cta = ctaEl?.dataset['cta'] || "inline";

        // Device class from user agent
        const ua = navigator.userAgent || "";
        const device = /Mobi|Android|iPhone|iPod|IEMobile|Opera Mini/i.test(ua)
          ? "mobile"
          : /iPad|Tablet/i.test(ua)
          ? "tablet"
          : "desktop";

        trackEvent("click_to_call", window.location.pathname, {
          cta,
          device,
          href: anchor.href,
        });
        gtagEvent("click_to_call", {
          event_category: "engagement",
          event_label: cta,
          cta_location: cta,
          device,
        });
        // Mark as a GA4 conversion (recommended event)
        gtagEvent("generate_lead", {
          event_category: "engagement",
          event_label: `call:${cta}`,
          lead_source: "phone_call",
          cta_location: cta,
          device,
          currency: "USD",
          value: 1,
        });
      }
    };
    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, []);

  return null;
};

export default PageViewTracker;
